<!--suppress ALL -->
<template lang="pug">
  material-card.v-card--material-stats(v-bind='$attrs', v-on='$listeners')
    v-card.pa-4(slot='offset', :class='`elevation-${elevation}`', :color='color', dark='')
      v-icon(size='40')
        | {{ icon }}
    .text-right
      p.category.grey--text.font-weight-light(v-text='title')
      h3.title.display-1.font-weight-light
        | {{ value }}
        small {{ smallValue }}
    template(slot='actions')
      v-tooltip(bottom, v-if='subText')
        template(v-slot:activator='{ on, attrs }')
          div.d-flex.align-center(style='min-width: 0; flex: 1;', v-bind='attrs', v-on='on')
            v-icon.mr-2(:color='subIconColor', size='20', style='flex-shrink: 0;')
              | {{ subIcon }}
            span.caption.font-weight-light.text-truncate(:class='subTextColor', style='overflow: hidden; text-overflow: ellipsis; white-space: nowrap; min-width: 0; flex: 1;') {{ subText }}
        span {{ subText }}
      div.d-flex.align-center(v-else, style='min-width: 0; flex: 1;')
        v-icon.mr-2(:color='subIconColor', size='20', style='flex-shrink: 0;')
          | {{ subIcon }}
        span.caption.font-weight-light(:class='subTextColor') {{ subText }}
</template>

<script>
import Card from './Card'

export default {
  inheritAttrs: false,

  props: {
    ...Card.props,
    icon: {
      type: String,
      required: true
    },
    subIcon: {
      type: String,
      default: undefined
    },
    subIconColor: {
      type: String,
      default: undefined
    },
    subTextColor: {
      type: String,
      default: undefined
    },
    subText: {
      type: String,
      default: undefined
    },
    title: {
      type: String,
      default: undefined
    },
    value: {
      type: String,
      default: undefined
    },
    smallValue: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style lang="scss">
.v-card--material-stats {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  overflow: visible !important; // Garante que o card não corte o conteúdo

  .v-offset {
    display: inline-block;
    flex: 0 1;
    margin-top: 0;
    margin-left: 0;
    margin-right: auto;
    margin-bottom: 0 !important;
    max-width: auto;
    padding: 0 16px 0;
    overflow: visible !important; // Garante que o offset não corte o conteúdo
  }

  .v-card {
    border-radius: 12px; // Border radius moderno
    flex: 0 1 auto;
    overflow: visible !important; // Garante que o card interno não corte o ícone
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    // Hover effect moderno
    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.2) !important;
    }
  }

  .v-card__text {
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    padding: 16px 16px 0 16px; // Padding adequado em todos os lados
    min-height: 80px; // Altura mínima para garantir espaço para o conteúdo
  }
  
  .text-right {
    padding-right: 16px;
    padding-left: 16px;
    min-width: 0; // Permite que o texto seja truncado se necessário
    flex: 1;
    
    .category {
      margin-bottom: 8px;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
    
    .title {
      word-wrap: break-word;
      overflow-wrap: break-word;
      line-height: 1.2;
    }
  }

  .v-card__actions {
    flex: 1 0 100%;
    padding: 12px 16px !important; // Padding adequado para evitar corte
    min-height: 48px; // Altura mínima para garantir espaço
    display: flex;
    align-items: center;
    overflow: visible !important; // Garante que tooltips não sejam cortados
    word-wrap: break-word; // Quebra palavras longas se necessário
  }

  // Garante que o ícone tenha espaço adequado
  .v-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
  }

  // Adiciona padding extra ao card com offset para evitar corte
  > .v-card {
    padding-bottom: 12px !important;
    min-height: 140px; // Altura mínima para garantir espaço adequado
  }
  
  // Garante que o card não corte conteúdo em telas menores
  @media (max-width: 600px) {
    .v-card__actions {
      padding: 8px 12px !important;
      font-size: 0.75rem;
    }
    
    .text-right {
      padding: 12px;
      
      .title {
        font-size: 1.5rem !important;
      }
    }
  }
}
</style>
